
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { loginreq, req, reqPost, exportExcelPost } from './api/axiosFun.js'
import store from './vuex/store.js'
import axios from 'axios'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 添加响应拦截器来处理415状态码和B0002错误码
axios.interceptors.response.use(
  response => {
    // 检查响应数据中的code是否为B0002
    if (response.data && response.data.code === "B0002") {
      // 清除本地存储的登录信息
      localStorage.removeItem('logintoken');
      localStorage.removeItem('userdata');

      // 跳转到登录页面
      router.push('/login');
      return response;
    }
    return response;
  },
  error => {
    // 检查响应状态码是否为415
    if (error.response && error.response.status === 415) {
      // 清除本地存储的登录信息
      localStorage.removeItem('logintoken');
      localStorage.removeItem('userdata');

      // 跳转到登录页面
      router.push('/login');
    }
    return Promise.reject(error);
  }
);

// 设置axios实例到Vue原型
Vue.prototype.$axios = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js